import { Link } from "react-router-dom";

import logo from "assets/images/Logo.svg";
import searchStyles from "components/Header/components/HeaderSearch/HeaderSearch.module.css";
import { ProfileDropdown } from "components/Header/components/ProfileDropdown/ProfileDropdown";
import { Button } from "components/ui/Button";
import { PatientAutocomplete } from "components/ui/PatientAutocomplete/PatientAutocomplete";
import { pathGenerators } from "utils/routes";

import styles from "./HeaderMobile.module.css";

export function HeaderMobile({ searchProps, profileProps }) {
  return (
    <header className={styles.header}>
      <div className={styles.logoSection}>
        <Link to={pathGenerators.global.home()} className={styles.headerLogo}>
          <img src={logo} alt="Kinesin" />
        </Link>
      </div>
      <div className={styles.actionsSection}>
        <div className={searchStyles.searchWrapper}>
          <PatientAutocomplete {...searchProps} id="header-search-mobile" />
        </div>
        <Button
          as={Link}
          to={pathGenerators.global.appointments()}
          variant="primary"
          size="large"
        >
          Appointments
        </Button>
        <ProfileDropdown {...profileProps} />
      </div>
    </header>
  );
}
